import React, { useState } from 'react';
import IconDown from '@assets/icon/chevron-down-red.svg'
import IconUp from '@assets/icon/chevron-up-red.svg';
import Link from '@components/Link';
import { styled } from '@linaria/react';

const Container = styled.div<StyledProps>`
  text-align: start;
  margin: ${props => typeof props.margin === 'number' ? `${props.margin}px` : props.margin};
`

const Content = styled.div<StyledProps>`
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
  height: ${props => props.isOpen ? 'auto' : '0px'};
  transition: height 5.18s linear;
  
`

interface StyledProps {
  theme?: any;
  isOpen?: boolean;
  margin: string | number;
}



export interface TextCollapsibleProps {
  theme?: any;
  labelMore: string;
  labelLess: string;
  children: React.ReactNode;
  margin: string | number;
  expanded: boolean;
  slotContent: 'start' | 'end';
}

function TextCollapsible({ labelMore, children, margin, expanded, labelLess, slotContent }: TextCollapsibleProps) {
  const [isOpen, setIsOpen] = useState(expanded);
  const toggling = () => setIsOpen(!isOpen);
  const icon = isOpen ? IconUp : IconDown;
  return <Container margin={margin}>
    {slotContent === 'start' && (
      <Content isOpen={isOpen} margin={margin}>{children}</Content>
    )}
    <Link fontWeight="bold" onClick={toggling} variant='button' iconSize="xsm" text={isOpen ? labelLess : labelMore} icon={icon}></Link>
    {slotContent === 'end' && (
      <Content isOpen={isOpen} margin={margin}>{children}</Content>
    )}
  </Container>;
};

TextCollapsible.defaultProps = {
  labelMore: 'Know more',
  labelLess: 'Know less',
  margin: 0,
  expanded: false,
  slotContent: 'start'
}

export default TextCollapsible;
